import React from 'react';

function Badge({ text, kind }) {
  return <span className={`badge ${kind}`}>{text}</span>;
}

export default Badge;
